import React, { useState } from 'react'
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert
} from '@mui/material'
import { format } from 'date-fns'
import axios from 'axios'

const AddSection = ({ profileId }) => {
  const [open, setOpen] = useState(false)
  const [sectionName, setSectionName] = useState('')
  const [description, setDescription] = useState('')
  const [totalRules, setTotalRules] = useState(0)
  const [createdDate, setCreatedDate] = useState(
    format(new Date(), 'yyyy-MM-dd')
  )
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [snackbarSeverity, setSnackbarSeverity] = useState('success')

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false)
  }

  const handleSave = () => {
    const payload = {
      appetite_profile_id: profileId,
      name: sectionName,
      description,
      created_at: createdDate,
      total_rules: totalRules
    }
    axios
      .post(
        'https://insureai-appetite-mgmt-1074099157700.us-central1.run.app/sections/',
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      .then(response => {
        setSnackbarMessage('Section added successfully!')
        setSnackbarSeverity('success')
        setSnackbarOpen(true)
      })
      .catch(error => {
        setSnackbarMessage('Failed to add section.')
        setSnackbarSeverity('error')
        setSnackbarOpen(true)
        console.error('Error:', error)
      })
    handleClose()
  }

  return (
    <div className='items-right h-full mb-4 mx-auto w-full right-view text-right'>
      <div className="flex justify-between items-center">
        <h1 className='font-semibold text-2xl text-orange-600'>Sections</h1>
        <Button
          variant='contained'
          color='primary'
          onClick={handleClickOpen}
          style={{
            backgroundColor: '#ea580c',
            color: 'white',
            padding: '5px 15px'
          }}
        >
          + Add Section
        </Button>
      </div>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          <h1 className='py-2 text-2xl text-orange-600'>
            Add Section
          </h1>
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin='dense'
            label='Section Name'
            type='text'
            fullWidth
            variant='outlined'
            value={sectionName}
            onChange={e => setSectionName(e.target.value)}
            className='mb-4'
          />
          <TextField
            margin='dense'
            label='Description'
            type='text'
            fullWidth
            variant='outlined'
            multiline
            rows={4}
            value={description}
            onChange={e => setDescription(e.target.value)}
            className='mb-4'
          />
          <TextField
            margin='dense'
            label='Total Number of Rules'
            type='number'
            fullWidth
            variant='outlined'
            value={totalRules}
            onChange={e => setTotalRules(e.target.value)}
            className='mb-4'
          />
          <TextField
            margin='dense'
            label='Created Date'
            type='date'
            fullWidth
            variant='outlined'
            value={createdDate}
            onChange={e => setCreatedDate(e.target.value)}
            className='mb-4'
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='secondary' variant='outlined'>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            style={{ backgroundColor: '#ea580c', color: 'white' }}
            variant='contained'
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default AddSection
